import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Search, Globe } from "lucide-react";

export const RatesExplorer = () => {
  const [rates, setRates] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback((q = "") => {
    setLoading(true);
    api.get("/rates", { params: q ? { search: q } : {} }).then(({ data }) => {
      setRates(data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const t = setTimeout(() => load(search), 250);
    return () => clearTimeout(t);
  }, [search, load]);

  const renderBody = () => {
    if (loading) return <div className="p-8 text-center text-zinc-400">Loading rates…</div>;
    if (rates.length === 0) return <div className="p-8 text-center text-zinc-400">No destinations found.</div>;
    return (
      <table className="w-full" data-testid="rates-table">
        <thead className="bg-zinc-50 border-b border-black/10">
          <tr className="text-left text-xs uppercase tracking-wide text-zinc-400 font-bold">
            <th className="px-5 py-3">Destination</th>
            <th className="px-5 py-3">Code</th>
            <th className="px-5 py-3 text-right">Rate / min</th>
          </tr>
        </thead>
        <tbody>
          {rates.map((r) => (
            <tr key={r.id} className="border-b border-black/5 last:border-0 hover:bg-zinc-50" data-testid={`rate-row-${r.iso}`}>
              <td className="px-5 py-3.5 font-semibold">
                <span className="mr-2">{r.flag}</span> {r.country}
              </td>
              <td className="px-5 py-3.5 font-mono text-zinc-500 text-sm">{r.dial_code}</td>
              <td className="px-5 py-3.5 text-right font-mono font-bold text-primary">${r.rate.toFixed(3)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <div className="relative my-6">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-400" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search country or dial code…"
          data-testid="rates-search"
          className="w-full bg-white border border-black/10 rounded-xl pl-11 pr-4 py-3 focus:ring-2 focus:ring-primary outline-none transition-all"
        />
      </div>

      <div className="bg-white border border-black/10 rounded-2xl overflow-hidden shadow-sm">
        {renderBody()}
      </div>
    </>
  );
};

export default function Rates() {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="flex items-center gap-3 mb-2">
        <div className="h-10 w-10 rounded-xl bg-accent flex items-center justify-center">
          <Globe className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight">Calling rates</h1>
          <p className="text-zinc-500 text-sm">Transparent per-minute pricing by destination.</p>
        </div>
      </div>
      <RatesExplorer />
    </div>
  );
}
